import styled from 'styled-components'

export const CardWaitingOn = styled.div`
  background-color: #fef9f2;
  padding: 16px 32px;
  border-radius: 8px;
  margin-bottom: 24px;

  .show-more-style {
    cursor: pointer;
    margin-bottom: 24px;
    margin-top: 10px;
    padding-left: 8px;
  }

  .more-style {
    height: 90px;
    overflow: hidden;
  }

  .less-style {
    /* height: fit-content; */
  }

  .header-in-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;

    .group-text-header {
      display: flex;
      column-gap: 8px;
      align-items: center;
      p {
        font-size: 16px;
        font-weight: 400;
        color: #fdc200;
        margin-top: 1px;
      }
    }

    .border-task {
      padding: 0px 8px;
      border-radius: 50px;
      background: var(--disable-default-disable-default, #e4e7ec);
      display: flex;
      align-items: center;
      p {
        color: #98a2b3;
        margin-top: 1px;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  .text-discaption {
    margin-bottom: 24px;
    p {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      color: #98a2b3;
    }
  }
  .group-task-assinge {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    height: 30px;
    align-items: center;
    padding: 8px;

    .task-name {
      display: flex;
      gap: 8px;
      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #101828;
      }
    }

    .planned-date {
      display: flex;
      gap: 8px;

      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #101828;
      }
      .btn-delete {
      }
    }
    &:hover {
      cursor: pointer;
      border-radius: 8px;
      opacity: 0.8;
      background: #fef5ea;
    }
  }
  .group-add-task {
    .text-add-task {
      display: flex;
      align-items: center;
      column-gap: 8px;
      align-items: flex-start;
      cursor: pointer;
      .icon-add {
        font-size: 14px;
        color: #0086c9;
      }
      .text-add {
        font-size: 14px;
        font-weight: 400;
        color: #0086c9;
      }
    }
    .form-add-task {
      display: grid;
      grid-template-columns: auto 48px;
      background-color: white;
      padding: 8px;
      border-radius: 8px;

      .btn-done {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        color: #004e91;
        justify-content: end;
      }
    }
  }
`

export const CardBolcking = styled.div`
  background-color: #fbf2f2;
  padding: 16px 32px;
  border-radius: 8px;
  margin-bottom: 24px;

  .show-more-style {
    cursor: pointer;
    margin-bottom: 24px;
    margin-top: 10px;
    padding-left: 8px;
  }

  .more-style {
    height: 90px;
    overflow: hidden;
  }

  .less-style {
    /* height: fit-content; */
  }

  .header-in-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;

    .group-text-header {
      display: flex;
      column-gap: 8px;
      align-items: center;
      p {
        font-size: 16px;
        font-weight: 400;
        color: #d21419;
        margin-top: 1px;
      }
    }

    .border-task {
      padding: 0px 8px;
      border-radius: 50px;
      background: var(--disable-default-disable-default, #e4e7ec);
      display: flex;
      align-items: center;
      p {
        color: #98a2b3;
        margin-top: 1px;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  .text-discaption {
    margin-bottom: 24px;
    p {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      color: #98a2b3;
    }
  }
  .group-task-assinge {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    height: 30px;
    align-items: center;
    padding: 8px;

    .task-name {
      display: flex;
      gap: 8px;
      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #101828;
      }
    }

    .planned-date {
      display: flex;
      gap: 8px;

      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #101828;
      }
      .btn-delete {
      }
    }
    &:hover {
      cursor: pointer;
      border-radius: 8px;
      opacity: 0.8;
      background: #f8e5e5;
    }
  }
  .group-add-task {
    .text-add-task {
      display: flex;
      align-items: center;
      column-gap: 8px;
      align-items: flex-start;
      cursor: pointer;
      .icon-add {
        font-size: 14px;
        color: #0086c9;
      }
      .text-add {
        font-size: 14px;
        font-weight: 400;
        color: #0086c9;
      }
    }
    .form-add-task {
      display: grid;
      grid-template-columns: auto 48px;
      background-color: white;
      padding: 8px;
      border-radius: 8px;

      .btn-done {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        color: #004e91;
        justify-content: end;
      }
    }
  }
`

export const CardTasks = styled.div`
  background-color: #f5fafe;
  padding: 16px 32px;
  border-radius: 8px;

  .show-more-style {
    cursor: pointer;
    margin-bottom: 24px;
    margin-top: 10px;
    padding-left: 8px;
  }

  .more-style {
    height: 90px;
    overflow: hidden;
  }

  .less-style {
    /* height: fit-content; */
  }

  .header-in-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;

    .group-text-header {
      display: flex;
      column-gap: 8px;
      align-items: center;
      p {
        font-size: 16px;
        font-weight: 400;
        color: #074e9f;
        margin-top: 1px;
      }
    }

    .border-task {
      padding: 0px 8px;
      border-radius: 50px;
      background: var(--disable-default-disable-default, #e4e7ec);
      display: flex;
      align-items: center;
      p {
        color: #98a2b3;
        margin-top: 1px;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  .text-discaption {
    margin-bottom: 24px;
    p {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      color: #98a2b3;
    }
  }
  .group-task-assinge {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    height: 30px;
    align-items: center;
    padding: 8px;

    .task-name {
      display: flex;
      gap: 8px;
      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #101828;
      }
    }

    .planned-date {
      display: flex;
      gap: 8px;

      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #101828;
      }
      .btn-delete {
      }
    }
    &:hover {
      cursor: pointer;
      border-radius: 8px;
      opacity: 0.8;
      background: #ecf2f8;
    }
  }
  .group-add-task {
    .text-add-task {
      display: flex;
      align-items: center;
      column-gap: 8px;
      align-items: flex-start;
      cursor: pointer;
      .icon-add {
        font-size: 14px;
        color: #0086c9;
      }
      .text-add {
        font-size: 14px;
        font-weight: 400;
        color: #0086c9;
      }
    }
    .form-add-task {
      display: grid;
      grid-template-columns: auto 48px;
      background-color: white;
      padding: 8px;
      border-radius: 8px;

      .btn-done {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        color: #004e91;
        justify-content: end;
      }
    }
  }
`

export const CardWaitingOnModal = styled.div`
  background-color: #fef9f2;
  padding: 16px 32px;
  border-radius: 8px;
  margin-bottom: 24px;

  .more-style {
    height: 0px;
    overflow: hidden;
  }

  .less-style {
    /* height: fit-content; */
  }

  .header-in-card {
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    .group-text-header {
      display: flex;
      column-gap: 8px;
      align-items: center;
      p {
        font-size: 16px;
        font-weight: 400;
        color: #fdc200;
        margin-top: 1px;
      }
    }

    .border-task {
      padding: 0px 8px;
      border-radius: 50px;
      background: var(--disable-default-disable-default, #e4e7ec);
      display: flex;
      align-items: center;
      p {
        color: #98a2b3;
        margin-top: 1px;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }

  .group-task-assinge {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    height: 30px;
    align-items: center;
    padding: 8px;
    margin-top: 24px;

    .task-name {
      display: flex;
      gap: 8px;
      .dot {
        border: 4px solid black;
        border-radius: 50px;
        height: 1px;
        display: flex;
        align-self: center;
      }
      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #101828;
      }
    }

    .planned-date {
      display: flex;
      gap: 8px;

      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #101828;
      }
      .btn-delete {
      }
    }
    &:hover {
      cursor: pointer;
      border-radius: 8px;
      opacity: 0.8;
      background: #fef5ea;
    }
  }
`

export const CardBolckingModal = styled.div`
  background-color: #fbf2f2;
  padding: 16px 32px;
  border-radius: 8px;
  margin-bottom: 24px;

  .more-style {
    height: 0px;
    overflow: hidden;
  }

  .less-style {
    /* height: fit-content; */
  }

  .header-in-card {
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    .group-text-header {
      display: flex;
      column-gap: 8px;
      align-items: center;
      p {
        font-size: 16px;
        font-weight: 400;
        color: #d21419;
        margin-top: 1px;
      }
    }

    .border-task {
      padding: 0px 8px;
      border-radius: 50px;
      background: var(--disable-default-disable-default, #e4e7ec);
      display: flex;
      align-items: center;
      p {
        color: #98a2b3;
        margin-top: 1px;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }

  .group-task-assinge {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    height: 30px;
    align-items: center;
    padding: 8px;
    margin-top: 24px;

    .task-name {
      display: flex;
      gap: 8px;
      .dot {
        border: 4px solid black;
        border-radius: 50px;
        height: 1px;
        display: flex;
        align-self: center;
      }
      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #101828;
      }
    }

    .planned-date {
      display: flex;
      gap: 8px;

      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #101828;
      }
      .btn-delete {
      }
    }
    &:hover {
      cursor: pointer;
      border-radius: 8px;
      opacity: 0.8;
      background: #f8e5e5;
    }
  }
`

export const CardTasksModal = styled.div`
  background-color: #f5fafe;
  padding: 16px 32px;
  border-radius: 8px;

  .more-style {
    height: 0px;
    overflow: hidden;
  }

  .less-style {
    /* height: fit-content; */
  }

  .header-in-card {
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    .group-text-header {
      display: flex;
      column-gap: 8px;
      align-items: center;
      p {
        font-size: 16px;
        font-weight: 400;
        color: #074e9f;
        margin-top: 1px;
      }
    }

    .border-task {
      padding: 0px 8px;
      border-radius: 50px;
      background: var(--disable-default-disable-default, #e4e7ec);
      display: flex;
      align-items: center;
      p {
        color: #98a2b3;
        margin-top: 1px;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }

  .group-task-assinge {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    height: 30px;
    align-items: center;
    padding: 8px;
    margin-top: 24px;

    .task-name {
      display: flex;
      gap: 8px;
      .dot {
        border: 4px solid black;
        border-radius: 50px;
        height: 1px;
        display: flex;
        align-self: center;
      }
      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #101828;
      }
    }

    .planned-date {
      display: flex;
      gap: 8px;

      p {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: #101828;
      }
      .btn-delete {
      }
    }
    &:hover {
      cursor: pointer;
      border-radius: 8px;
      opacity: 0.8;
      background: #ecf2f8;
    }
  }
`
